import React from "react";
import Select from "@8x8/oxygen-select";
import { cellErrors } from "@/react/components/table/useTableMutations";
import useEditableCell from "@/react/components/table/useEditableCell";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import { useGetDialplansQuery } from "@/react/services/common/customerDialplansApi";
import { ValidationWrapper } from "@/react/components/table/components";

const DialPlanNameSelect = (dialPlanNameCellProps) => {
  const errors = cellErrors(dialPlanNameCellProps);
  const { value, onChange, onBlur } = useEditableCell(dialPlanNameCellProps);

  const { data, isFetching } = useGetDialplansQuery();

  const options = Object.values(data || []).map((dialPlan) => ({
    value: dialPlan.name,
    label: dialPlan.name,
  }));

  const selectedValue = options.find((option) => option.value === value);

  return (
    <FullWidthDiv>
      <ValidationWrapper errors={errors}>
        <Select
          size={"small"}
          testId={"dial-plan-name-select"}
          isDisabled={isFetching}
          options={options}
          value={selectedValue}
          onChange={(opt) => onChange(opt?.value)}
          onBlur={onBlur}
          hasError={errors.length > 0}
          isClearable={true}
          isSearchable={true}
          placeholder={isFetching ? `Loading...` : `Select the dial plan name`}
        />
      </ValidationWrapper>
    </FullWidthDiv>
  );
};

export default DialPlanNameSelect;
